import { AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { onSuccessProps } from '../../../components/auth/login/Login';
import { GET_AUTH_FAILURE, GET_AUTH_REQUEST, GET_AUTH_SUCCESS, RESET_VALIDATION_MESSAGE } from '../constants/auth.constant';
import { Module } from '../../../components/roles/rolePermission/RolePermission';
import { noPermissionsAssigned, setUserPermission } from '../../setInitialPermission/actions/setInitialPermission.action';

const getAuthRequest = () => {
    return {
        type: GET_AUTH_REQUEST,
    };
};

const getAuthSuccess = (authData: AnyIfEmpty<object>) => {
    return {
        type: GET_AUTH_SUCCESS,
        payload: authData,
    };
};

const getAuthFailure = (authError: AnyIfEmpty<object>) => {
    return {
        type: GET_AUTH_FAILURE,
        payload: authError,
    };
};

export const resetValidationMessage = () => {
    return {
        type: RESET_VALIDATION_MESSAGE,
    };
};

export const getAuth = (loginDetails: { email: string; password: string, loginTimestamp: number }, onSuccess: (data: onSuccessProps) => void) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAuthRequest());
        axios.post(`/admin/login`, loginDetails).then((response: AxiosResponse) => {
            if (response.data.statusCode === 200) {
                dispatch(getAuthSuccess(response.data));
                if (response?.data?.rolesPermission?.statusCode === 404) {
                    dispatch(noPermissionsAssigned())
                } else if (!response?.data?.rolesPermission) {
                    dispatch(noPermissionsAssigned())
                } else {
                    dispatch(setUserPermission(response?.data?.rolesPermission?.rolesPermission))
                }
                localStorage.setItem('adminAccessToken', response.data.token);
                localStorage.setItem('email', loginDetails.email);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                onSuccess(response.data);
            } else {
                dispatch(getAuthFailure(response.data.message));
            }
        }).catch((error) => {
            if (error?.response?.data?.statusCode) {
                dispatch(getAuthFailure(error.response.data.message))
            } else {
                dispatch(getAuthFailure(error.response.data.message[0]))
            }
        });
    };
};


export const getAdminDetails = (onSucces?: (data: Module[]) => void, onFailure?: () => void) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        axios.get('/admin/me').then((response: AxiosResponse) => {
            if (response?.data?.rolesPermission) {
                onSucces?.(response?.data?.rolesPermission)
                if (response?.data?.rolesPermission) {
                    dispatch(setUserPermission(response?.data?.rolesPermission))
                } else {
                    dispatch(noPermissionsAssigned());
                }
            } else {
                onFailure?.()
                dispatch(noPermissionsAssigned());
            }
        }).catch(() => {
            onFailure?.()
            dispatch(noPermissionsAssigned());
        })
    }
}